import { DigitalProduct } from "../../../../Redux/digital-product/types";

const DetailPageMoreInformation = ({
  product,
  selectedVariation,
}: {
  product: DigitalProduct;
  selectedVariation: number;
}) => {
  if (!product) return null;

  return (
    <>
      <div className="accordion-1">
        <div className="row position-static">
          <div className="col-md-12">
            <div className="accordion " id="accordionRental">
              <div className="accordion-item mb-0">
                <h6 className="accordion-header" id="headingOne">
                  <button
                    className="accordion-button border-bottom font-weight-bold collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="false"
                    aria-controls="collapseOne"
                  >
                    About this item
                  </button>
                </h6>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionRental"
                >
                  <div className="accordion-body text-start text-sm">
                    <div className=" mt-3">
                      <ul>
                        {product?.bulletPoints?.map((item, index) => (
                          <li className="mb-2" key={index}>
                            <b className="text-black text-normal text-capitalize">
                              {item}
                            </b>
                          </li>
                        ))}

                        <li
                          className={`mb-2 ${product?.categoryDetails?.category ? "d-block" : "d-none"}`}
                        >
                          <b className="text-black text-normal text-capitalize">
                            Generic Name : {product?.categoryDetails?.category}
                          </b>
                        </li>
                        <li
                          className={`mb-2 ${product?.brand ? "d-block" : "d-none"}`}
                        >
                          <b className="text-black text-normal text-capitalize">
                            Brand : {product?.brand}
                          </b>
                        </li>
                        <li
                          className={`mb-2 ${product?.ssin ? "d-block" : "d-none"}`}
                        >
                          <b className="text-black text-normal text-capitalize">
                            SSIN : {product?.ssin}
                          </b>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordion-item mb-0">
                <h6 className="accordion-header" id="headingFour">
                  <button
                    className="accordion-button border-bottom font-weight-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    Disclaimer
                  </button>
                </h6>
                <div
                  id="collapseFour"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingFour"
                  data-bs-parent="#accordionRental"
                >
                  <div className="accordion-body text-start text-sm opacity-8">
                    {product?.productDescription}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailPageMoreInformation;
